if (!customElements.get('dm-usp-bar')) {
  customElements.define(
    'dm-usp-bar',
    class DmUspBar extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('.dm-usp-bar__item'));
        if (this.items.length < 2) return;

        this.index = Math.max(
          0,
          this.items.findIndex((item) => item.classList.contains('is-active'))
        );
        this.interval = parseInt(this.dataset.interval, 10) || 2600;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = window.matchMedia('(max-width: 749px)');

        this.onMediaChange = this.start.bind(this);
        this.reducedMotion.addEventListener('change', this.onMediaChange);
        this.mobile.addEventListener('change', this.onMediaChange);

        this.start();
      }

      disconnectedCallback() {
        this.stop();
        if (this.reducedMotion) this.reducedMotion.removeEventListener('change', this.onMediaChange);
        if (this.mobile) this.mobile.removeEventListener('change', this.onMediaChange);
      }

      start() {
        this.stop();
        if (this.reducedMotion.matches || !this.mobile.matches) return;
        this.timer = setInterval(() => this.next(), this.interval);
      }

      stop() {
        if (this.timer) clearInterval(this.timer);
        this.timer = null;
      }

      next() {
        this.items[this.index].classList.remove('is-active');
        this.index = (this.index + 1) % this.items.length;
        this.items[this.index].classList.add('is-active');
      }
    }
  );
}
